import { WorkerMenuPriviliges } from "../priviligesProviders/WorkerMenuPriviligesProvider";
import { type NavigationItem, type NavigationMenu, type NavigationSection } from "./types";
import { getRouteAndSelected } from "./utils";

export function getWorkerNavigationMenu(
  workerMenuPriviliges: WorkerMenuPriviliges,
  currentPath: string
): NavigationMenu {
  const items: Array<NavigationItem | NavigationSection> = [];

  if (workerMenuPriviliges.dashboard) {
    items.push({
      label: "Calendar",
      iconType: "calendar",
      ...getRouteAndSelected("agentDashboard", currentPath),
    });
  }

  if (workerMenuPriviliges.chat) {
    items.push({
      label: "Chat",
      iconType: "message",
      ...getRouteAndSelected("facilityChat", currentPath),
    });
  }

  if (workerMenuPriviliges.dnr) {
    items.push({
      label: "DNR",
      iconType: "gps-disabled",
      ...getRouteAndSelected("agentDnr", currentPath),
    });
  }

  if (workerMenuPriviliges.payrollSection) {
    const sectionItems: NavigationItem[] = [];

    if (workerMenuPriviliges.payrollSection.payroll) {
      sectionItems.push({
        label: "Payroll",
        iconType: "money-dollar",
        ...getRouteAndSelected("agentPayroll", currentPath),
      });
    }
    if (workerMenuPriviliges.payrollSection.stripeTransfers) {
      sectionItems.push({
        label: "Stripe Transfers",
        iconType: "dollar",
        ...getRouteAndSelected("agentStripeTransfers", currentPath),
      });
    }
    if (workerMenuPriviliges.payrollSection.stripePayouts) {
      sectionItems.push({
        label: "Stripe Payouts",
        iconType: "palm-dollar",
        ...getRouteAndSelected("agentStripePayouts", currentPath),
      });
    }

    items.push({ label: "Payroll", items: sectionItems });
  }

  if (workerMenuPriviliges.clipboardScore) {
    const sectionItems: NavigationItem[] = [];

    sectionItems.push({
      label: "Clipboard Score",
      iconType: "notepad-alt",
      ...getRouteAndSelected("agentAttendance", currentPath),
    });

    items.push({ label: "Clipboard Score", items: sectionItems });
  }

  if (workerMenuPriviliges.placementSection) {
    const sectionItems: NavigationItem[] = [];

    if (workerMenuPriviliges.placementSection.candidateProfile) {
      sectionItems.push({
        label: "Candidate Profile",
        iconType: "identity-card",
        ...getRouteAndSelected("agentPlacement", currentPath),
      });
    }
    if (workerMenuPriviliges.placementSection.exclusions) {
      sectionItems.push({
        label: "Exclusions",
        iconType: "folder-person",
        ...getRouteAndSelected("agentPlacementCandidateExclusions", currentPath),
      });
    }

    items.push({ label: "Placement", items: sectionItems });
  }

  return { items };
}
